var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
import cx from 'classnames';
const SvgIconComponent = (props, ref) => ((props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "m6.664 14.667 6.667 6.667 12-12"
}))))({
  ...props,
  className: cx('PA-Svg', props.className)
}, ref);
const SvgCheckmark = SvgIconComponent;
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmark);
export default ForwardRef;